// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ApplicationMode } from 'Core/enums';
import { Environment } from 'Core/interfaces';

export const environment: Environment = {
  apiUrl: 'https://dev.api.20-16-20.by',
  productUrl: 'https://dev.20-16-20.by',
  applicationMode: ApplicationMode.Dev,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
